
import React, { useState,useEffect } from "react";
import { saveJobLinksSection } from "../../api/api";
import { useGlobalData } from '../../context/GlobalDataContext';

const createRow = () => ({ text: "", color: "#222222", forceMode: null, fontSize: 15 });

function RowControls({ onAdd, onRemove, canRemove }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", justifyContent: "flex-end" }}>
      <button type="button" onClick={onAdd}>Add Row</button>
      <button type="button" onClick={onRemove} disabled={!canRemove}>Remove</button>
    </div>
  );
}

function JobLinksSectionAdminPanel({ darkMode }) {
  const { jobLinks = [],fetchJobLinks } = useGlobalData();
  const [rows, setRows] = useState(jobLinks.length ? jobLinks.map(row => ({ ...row })) : [createRow()]);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  // preload off hone par initial fetch
  useEffect(() => {
    if (!jobLinks.length && fetchJobLinks) {
      fetchJobLinks();
    }
  }, [jobLinks.length, fetchJobLinks]);

  // Ensure updateRowForceMode is defined in the correct scope
  const updateRowForceMode = (index, value) => {
    setRows((current) => current.map((row, rowIndex) => {
      let forceMode = null;
      if (value === 'light' || value === 'dark') forceMode = value;
      // value === '' means global
      return rowIndex === index ? { ...row, forceMode } : row;
    }));
  };

  // Sync with context updates
  useEffect(() => {
    setRows(jobLinks.length ? jobLinks.map(row => ({ ...row })) : [createRow()]);
  }, [jobLinks]);


   // Role check for superadmin only
  const role = localStorage.getItem('role');
  if (role !== 'superadmin') {
    return <div style={{ color: 'red', textAlign: 'center', marginTop: '2rem' }}>Access denied: Superadmin only</div>;
  }


  const updateRow = (index, value) => {
    setRows((current) => current.map((row, rowIndex) => (
      rowIndex === index ? { ...row, text: value } : row
    )));
  };

  const updateRowColor = (index, color) => {
    setRows((current) => current.map((row, rowIndex) => (
      rowIndex === index ? { ...row, color } : row
    )));
  };

  const addRow = () => {
    setRows((current) => [...current, createRow()]);
  };

  // Accepts either a delta (number) or an absolute value (object with {absolute: number})
  const updateRowFontSize = (index, valueOrDelta) => {
    setRows((current) => current.map((row, rowIndex) => {
      if (rowIndex !== index) return row;
      let newSize;
      if (typeof valueOrDelta === 'object' && valueOrDelta.absolute) {
        newSize = valueOrDelta.absolute;
      } else {
        newSize = Math.max(10, Math.min(40, (row.fontSize || 15) + valueOrDelta));
      }
      return { ...row, fontSize: newSize };
    }));
  };

  const removeRow = (index) => {
    setRows((current) => {
      const nextRows = current.filter((_, rowIndex) => rowIndex !== index);
      return nextRows.length ? nextRows : [createRow()];
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");

    try {

      const payload = {
        rows: rows
          .map((row) => ({
            text: row.text.trim(),
            color: row.color || "#222222",
            forceMode: row.forceMode === 'light' || row.forceMode === 'dark' ? row.forceMode : null,
            fontSize: typeof row.fontSize === 'number' ? row.fontSize : 15
          }))
          .filter((row) => row.text)
      };
      

      if (payload.rows.length === 0) {
        alert("❌ Kam se kam ek row text add kijiye.");
        return;
      }

      await saveJobLinksSection({
        rows: payload.rows
      });
      const successMessage = `✅ Top text section save ho gaya. Total rows: ${payload.rows.length}`;
      alert(successMessage);
      setMessage(successMessage);
       if (fetchJobLinks) {
        await fetchJobLinks();
      }
    } catch (submitError) {
      const errorMessage = submitError.response?.data?.error || submitError.message || "Unable to save job links section";
      setError(errorMessage);
    }
  };

  return (
    <div
      style={{
        backgroundColor: darkMode ? "#232836" : "#e0f7fa",
        padding: "20px",
        borderRadius: "8px",
        marginBottom: "30px",
        border: `2px solid ${darkMode ? '#1976d2' : '#0ea5e9'}`
      }}
    >
      <h2 style={{ color: darkMode ? "#60a5fa" : "#075985", marginTop: 0 }}>Top Text Section Admin Panel</h2>
      <p style={{ color: darkMode ? "#b0b8c9" : "#334155", marginBottom: "16px" }}>Yaha row-wise text add kijiye. Homepage ke top section me single column aur center aligned row ke form me dikhega.</p>

      <form
        onSubmit={handleSubmit}
        style={{
          backgroundColor: darkMode ? "#181c24" : "white",
          padding: "15px",
          borderRadius: "5px",
          marginBottom: "20px"
        }}
      >

        {rows.map((row, index) => (
          <div
            key={`job-links-row-${index}`}
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 140px", // More width for controls
              gap: "8px",
              marginBottom: "8px",
              alignItems: 'center',
              borderBottom: index !== rows.length - 1 ? `1.5px solid ${darkMode ? '#444' : '#b0b8c9'}` : 'none',
              paddingBottom: index !== rows.length - 1 ? '12px' : 0,
            }}
          >
            <textarea
              value={row.text}
              onChange={(event) => updateRow(index, event.target.value)}
              placeholder="Row text add kijiye"
              style={{
                minHeight: "36px",
                maxHeight: "60px",
                padding: "6px 8px",
                fontSize: row.fontSize || 15,
                color: row.color || "#222222",
                resize: "vertical",
                width: "100%",
                boxSizing: "border-box",
              }}
            />
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 6,
                minWidth: 120,
                width: '100%',
                boxSizing: 'border-box',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 4, margin: '2px 0' }}>
                <button type="button" onClick={() => updateRowFontSize(index, -1)} style={{ fontSize: 13, padding: '2px 6px', borderRadius: 4, border: `1px solid ${darkMode ? '#444' : '#b0b8c9'}`, background: darkMode ? '#232836' : '#f3f4f6', color: darkMode ? '#fff' : '#222', cursor: 'pointer' }}>A-</button>
                <span style={{ fontSize: 12, minWidth: 24, textAlign: 'center', color: darkMode ? '#fff' : '#222' }}>{row.fontSize || 15}px</span>
                <button type="button" onClick={() => updateRowFontSize(index, 1)} style={{ fontSize: 13, padding: '2px 6px', borderRadius: 4, border: `1px solid ${darkMode ? '#444' : '#b0b8c9'}`, background: darkMode ? '#232836' : '#f3f4f6', color: darkMode ? '#fff' : '#222', cursor: 'pointer' }}>A+</button>
                <select
                  value={row.fontSize || 15}
                  onChange={e => updateRowFontSize(index, { absolute: Number(e.target.value) })}
                  style={{ fontSize: 12, marginLeft: 6, borderRadius: 4, padding: '2px 4px', background: darkMode ? '#232836' : '#fff', color: darkMode ? '#fff' : '#222', border: `1px solid ${darkMode ? '#444' : '#b0b8c9'}` }}
                  title="Font size"
                >
                  {[12, 14, 15, 16, 18, 20, 22, 24, 28, 32, 36, 40].map(size => (
                    <option key={size} value={size}>{size}px</option>
                  ))}
                </select>
              </div>
              <input
                type="color"
                value={row.color || "#222222"}
                onChange={e => updateRowColor(index, e.target.value)}
                title="Select text color"
                style={{
                  width: 32,
                  height: 32,
                  border: `1.5px solid ${darkMode ? '#444' : '#b0b8c9'}`,
                  borderRadius: '8px',
                  background: darkMode ? '#181c24' : '#fff',
                  boxShadow: '0 2px 8px rgba(60,60,60,0.07)',
                  cursor: 'pointer',
                  padding: 0,
                  transition: 'box-shadow 0.2s, border-color 0.2s',
                  marginBottom: 2,
                }}
                onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 12px rgba(37,99,235,0.18)'}
                onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px rgba(60,60,60,0.07)'}
              />
              {/* Toggle for forceMode */}
              <div style={{ display: 'flex', alignItems: 'center', margin: '4px 0' }}>
                <label style={{ fontSize: 11, marginRight: 4, color: darkMode ? '#fff' : '#222' }}>Mode:</label>
                <select
                  value={row.forceMode === 'light' ? 'light' : row.forceMode === 'dark' ? 'dark' : ''}
                  onChange={e => updateRowForceMode(index, e.target.value)}
                  style={{ fontSize: 12, padding: '2px 4px', borderRadius: 4, background: darkMode ? '#232836' : '#fff', color: darkMode ? '#fff' : '#222', border: `1px solid ${darkMode ? '#444' : '#b0b8c9'}` }}
                >
                  <option value="">Global</option>
                  <option value="light">Light</option>
                  <option value="dark">Dark</option>
                </select>
              </div>
              <RowControls onAdd={addRow} onRemove={() => removeRow(index)} canRemove={rows.length > 1} />
            </div>
          </div>
        ))}


        {message && <div style={{ marginTop: "16px", padding: "12px", borderRadius: "6px", backgroundColor: darkMode ? "#1a2e22" : "#e8f5e9", color: darkMode ? "#7ee787" : "#2e7d32" }}>{message}</div>}
        {error && <div style={{ marginTop: "16px", padding: "12px", borderRadius: "6px", backgroundColor: darkMode ? "#2e1a1a" : "#ffebee", color: darkMode ? "#ff7b72" : "#c62828" }}>{error}</div>}

        <button
          type="submit"
          style={{
            width: "100%",
            marginTop: "18px",
            padding: "12px",
            backgroundColor: darkMode ? "#1976d2" : "#0284c7",
            color: "white",
            border: "none",
            borderRadius: "6px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
        >
          Save Top Text Section
        </button>
      </form>

      {/* Loading state handled by context or can be omitted */}
    </div>
  );
}

export default JobLinksSectionAdminPanel;